import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/_route/_internal/trending/')({
  beforeLoad: () => {
    throw redirect({ replace: true, to: '/trending/people' });
  },
});
